import { DialogContent, DialogHeader, DialogTitle, Button, Dialog } from '@ui/components';
import { Delete } from '@ui/components/icons';
import { useEffect, FC } from 'react';
import { t } from 'i18next';

import { VehiclesForm } from '../vehicles-form/vehicles-form';
import { useVehicleForm, VehicleForm } from '../../../hooks';

interface EditVehicleDialogProps {
  onSave: (vehicle: VehicleForm) => void;
  onOpenChange: (open: boolean) => void;
  onRemove: () => void;
  vehicle: VehicleForm;
  open: boolean;
}

export const EditVehicleDialog: FC<EditVehicleDialogProps> = (props) => {
  const { onOpenChange, open, vehicle, onSave, onRemove } = props;
  const { form } = useVehicleForm();

  const handleSubmitEditedVehicle = (modifiedVehicle: VehicleForm) => {
    onSave(modifiedVehicle);
  };

  // Set form values when dialog is opened
  useEffect(() => {
    form.reset(vehicle);
  }, [vehicle, form]);

  return (
    <Dialog
      onOpenChange={(open) => {
        if (!open) {
          form.reset(vehicle);
        }

        onOpenChange(open);
      }}
      open={open}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('ONBOARDING.ADD_VEHICLES.EDIT')}</DialogTitle>
          <Button className="ml-auto" onClick={onRemove} variant="ghost">
            <Delete className="size-4" />
          </Button>
        </DialogHeader>

        <div className="p-4">
          <VehiclesForm onSubmit={handleSubmitEditedVehicle} form={form} />
          <Button
            onClick={form.handleSubmit(handleSubmitEditedVehicle)}
            type="submit"
            size="large"
            wide
          >
            {t('ONBOARDING.ADD_VEHICLES.SAVE')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
